import { Skeleton } from '@any-ui-react/core';

import { Card } from '../card';

export const EmployeeHeaderLoader = () => (
  <Card className="flex w-full items-center justify-between">
    <div className="flex items-center">
      <div className="inline-block h-16 max-h-16 w-16 border">
        <Skeleton className="h-16 w-16" />
      </div>
      <div className="ml-6 flex flex-col space-y-2">
        <Skeleton className="h-6 w-[300px]" />
        <Skeleton className="block h-3.5 w-[220px]" />
        <Skeleton className="block h-3 w-[270px]" />
      </div>
    </div>
  </Card>
);
